var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPercentage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.14876 1.66134C10.3924 0.254134 14.1756 1.14308 16.4528 3.84783C18.7303 6.55258 18.9616 10.4317 17.0219 13.3881C15.0821 16.3444 11.4318 17.6768 8.04372 16.6647C4.65533 15.6529 2.33363 12.5371 2.33301 9.00101",
    stroke: "#DB6443",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5582 5.88965L7.33594 12.1119",
    stroke: "#DB6443",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00369 7.66656C8.61734 7.66656 9.1148 7.1691 9.1148 6.55545C9.1148 5.9418 8.61734 5.44434 8.00369 5.44434C7.39004 5.44434 6.89258 5.9418 6.89258 6.55545C6.89258 7.1691 7.39004 7.66656 8.00369 7.66656Z",
    stroke: "#DB6443",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8924 12.5562C13.506 12.5562 14.0035 12.0587 14.0035 11.4451C14.0035 10.8314 13.506 10.334 12.8924 10.334C12.2787 10.334 11.7812 10.8314 11.7812 11.4451C11.7812 12.0587 12.2787 12.5562 12.8924 12.5562Z",
    stroke: "#DB6443",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.114 11.6665L2.48552 8.99526L5.22439 10.5563",
    stroke: "#DB6443",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercentage);
export default __webpack_public_path__ + "static/media/percentage.f33c9596.svg";
export { ForwardRef as ReactComponent };